function isValidIsbnSearchTerm(searchTerms: string): string {
  if (searchTerms) {
    let isbnCheckSearchTerm: string = searchTerms;
    const dashRegex = /[-]/g;
    const nonIsbnCharactersRegex = /[^0-9xX]/g;
    isbnCheckSearchTerm = isbnCheckSearchTerm
      .replace(dashRegex, '')
      .replace(nonIsbnCharactersRegex, '');
    const alphaNumericRegex = /^[a-z0-9]+$/i;
    if (
      isbnCheckSearchTerm.match(alphaNumericRegex) &&
      isbnCheckSearchTerm.length >= 10 &&
      isbnCheckSearchTerm.length <= 14
    ) {
      return isbnCheckSearchTerm;
    }
  }
  return searchTerms;
}

export function processSearchTerms(searchTerms: string | undefined): string {
  if (searchTerms) {
    searchTerms = searchTerms.trim();
    const validIsbn: string = isValidIsbnSearchTerm(searchTerms);
    return validIsbn || searchTerms;
  }
  return searchTerms || '';
}
